import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/collections/license.invoiceFollowUpStatuses.query.gql"
import type {
  InvoiceFollowUpStatusesQuery,
  InvoiceFollowUpStatusesQueryVariables,
} from "@/v2-backoffice-client/license/collections/__types__/license.invoiceFollowUpStatuses.query"

export function useInvoiceFollowUpStatusesQuery(
  options?: QueryHookOptions<
    InvoiceFollowUpStatusesQuery,
    InvoiceFollowUpStatusesQueryVariables
  >,
) {
  return useQuery<
    InvoiceFollowUpStatusesQuery,
    InvoiceFollowUpStatusesQueryVariables
  >(query, options)
}
